/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  var drawers = document.getElementsByClassName('custom-drawer-pdp');
  var drawers_close = document.getElementsByClassName('drawer__close-custom');
  var drawer_elems = document.getElementsByClassName('drawer--custom');

  var openCustomDrawer = function() {
    var attribute = this.getAttribute("data-drawer-toggle");
    document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.add('is-open');

    document.querySelector('.product__content').classList.add('drawer-open');
  };

  var closeCustomDrawer = function() {
    var attribute = this.getAttribute("data-drawer-toggle");
    document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.add('is-closing');
    
    setTimeout(() => {
      document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.remove('is-open');
      document.querySelector('.drawer[data-drawer="'+attribute+'"]').classList.remove('is-closing');
          
      document.querySelector('.product__content').classList.remove('drawer-open');
    }, 200);
    
  };

  for (var i = 0; i < drawers.length; i++) {
    drawers[i].addEventListener('click', openCustomDrawer, false);
  }
  
  for (var i = 0; i < drawers_close.length; i++) {
    drawers_close[i].addEventListener('click', closeCustomDrawer, false);
  }

  document.addEventListener('keyup', (e) => {
    if (e.code === 'Escape') {
      for (var i = 0; i < drawer_elems.length; i++) {
        if (drawer_elems[i].classList.contains('is-open')) {
          drawer_elems[i].classList.add('is-closing');
          setTimeout(() => {
            drawer_elems[i].classList.remove('is-open');
            drawer_elems[i].classList.remove('is-closing');
            document.querySelector('.product__content').classList.remove('drawer-open');
          }, 200);
          return false;
        }
      }
    }
  });

  document.body.addEventListener('click', function (e) {
    if (e.target.hasAttribute('data-drawer-underlay')) {
      for (var i = 0; i < drawer_elems.length; i++) {
        if (drawer_elems[i].classList.contains('is-open')) {
          drawer_elems[i].classList.add('is-closing');
          setTimeout(() => {
            drawer_elems[i].classList.remove('is-open');
            drawer_elems[i].classList.remove('is-closing');
            document.querySelector('.product__content').classList.remove('drawer-open');
          }, 200);
          return false;
        }
      }
    }
  });



  // Colourway slides on product cards: when a sibling swatch is selected, swap that colourway's
  // images (pre-rendered in <template data-sibling-slides> by product-grid-item.liquid) into the
  // card's swipe (touch) / hover (desktop) slider.
  var showSiblingSlides = function(swatch) {
    var card = swatch.closest('[data-grid-item]');
    var hoverImages = card && card.querySelector('hover-images[data-sibling-slides-holder]');
    if (!hoverImages) return;

    var url = swatch.getAttribute('data-sibling-link');
    var imageHolder = hoverImages.closest('[data-product-image]');
    var templates = hoverImages.querySelectorAll('template[data-sibling-slides]');
    var template = null;
    for (var i = 0; i < templates.length; i++) {
      if (templates[i].getAttribute('data-sibling-slides') === url) template = templates[i];
    }

    // Colourway with fewer than 2 images: hide the slider so only its featured image (sibling layer) shows
    if (!template) {
      imageHolder.setAttribute('data-sibling-slides-state', 'none');
      return;
    }
    imageHolder.setAttribute('data-sibling-slides-state', 'match');

    // The first template is the card's own product, which is what the slider holds on page load
    var loadedUrl = hoverImages.getAttribute('data-loaded-slides') || templates[0].getAttribute('data-sibling-slides');
    if (loadedUrl === url) return;

    var slider = hoverImages.querySelector('[data-hover-slider]');

    if (hoverImages.flkty) {
      hoverImages.flkty.options.watchCSS = false;
      hoverImages.flkty.destroy();
      hoverImages.flkty = null;
    }

    slider.innerHTML = template.innerHTML;
    slider.scrollLeft = 0;
    hoverImages.style.setProperty('--slides-count', slider.querySelectorAll('[data-hover-slide-touch]').length);
    hoverImages.style.setProperty('--slider-index', 0);
    hoverImages.setAttribute('data-loaded-slides', url);

    if (!window.theme.touch && typeof hoverImages.initFlickity === 'function') {
      hoverImages.initFlickity();
    }
  };

  // Mirrors the theme's sibling swatch events (click, mouseenter, keyboard focus)
  var onSiblingSwatchEvent = function(e) {
    var swatch = e.target.closest && e.target.closest('[data-sibling-link]');
    if (swatch) showSiblingSlides(swatch);
  };
  document.addEventListener('click', onSiblingSwatchEvent);
  document.addEventListener('mouseover', onSiblingSwatchEvent);
  document.addEventListener('focusin', function(e) {
    if (document.body.classList.contains('is-focused')) onSiblingSwatchEvent(e);
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
